import React from 'react';
import {Feedbacks} from './blocks';
import {FeedbackData} from '@/pages/buddy/types/FeedbackData';

interface FeedbacksContentProps {
    feedbacks: FeedbackData[];
    loading: boolean;
}

const FeedbacksContent: React.FC<FeedbacksContentProps> = ({feedbacks, loading}) => {
    return (
        <div>
            <Feedbacks feedbacks={feedbacks} loading={loading}/>
        </div>
    );
};

export {FeedbacksContent};
